import { PlatformLocation } from '@angular/common';
import { Component, Input } from '@angular/core';

export interface LinksValue {
  title: string;
  items: LinksValueItem[];
}
export interface LinksValueItem {
  label: string;
  to: string;
  itemId: number | string;
}
export interface AdditionalLinksValue {
  label: string;
  to: string;
  itemId: number | string;
}

@Component({
  selector: 'lh-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  @Input() links: LinksValue[] = [];
  @Input() additionalLinks: AdditionalLinksValue[] = [];
  @Input() showArrowIcon = false;
  @Input() footerFixed = false;

  constructor(private plaformLocation: PlatformLocation) {}

  onClickArrowTop(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  onClickBrandLogo(): void {
    window.location.href = this.plaformLocation.getBaseHrefFromDOM();
  }
}
